import { PlusIcon } from "@heroicons/react/24/outline";

import Button from "~/atoms/buttons/Button";
import { DRAWER_CREATE_NEW } from "~/constants/general";
import useDrawers from "~/hooks/useDrawers";

const CreateNewButton: React.FC = () => {
  const { openDrawer } = useDrawers(DRAWER_CREATE_NEW);

  return (
    <Button
      onClick={() => openDrawer()}
      startAdornment={<PlusIcon className="h-5 w-5" />}
      fullWidth
      size="sm"
    >
      Create New
    </Button>
  );
};

export default CreateNewButton;
